// Brand logo block — TekWissen circular logo + optional wordmark.
// Use size="sm" (32px) for compact spots, "md" (40px) for headers, "lg" (64px) for hero areas.

const SIZE_MAP = { sm: 32, md: 40, lg: 64, xl: 96 };

export default function BrandLogo({
  size = "md",
  showText = true,
  title = "TekWissen Fun Zone",
  subtitle = "Where work meets play",
  className = "",
}) {
  const px = SIZE_MAP[size] || SIZE_MAP.md;
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <img
        src="/brand/tekwissen-logo.png"
        alt="TekWissen Group"
        width={px}
        height={px}
        className="rounded-full border-2 border-black bg-white object-contain flex-shrink-0"
        style={{ width: px, height: px }}
      />
      {showText && (
        <div className="leading-tight">
          <h1 className="font-black tracking-tight uppercase text-base sm:text-lg">{title}</h1>
          {subtitle && (
            <p className="text-[10px] sm:text-xs uppercase tracking-widest text-neutral-600">
              {subtitle}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
